export const StatCard = ({ label, value, sub, icon: Icon, tone = "emerald", testid, delay = 0 }) => {
  const tones = {
    emerald: ["bg-emerald-50 text-emerald-700", "#10b981"],
    amber: ["bg-amber-50 text-amber-700", "#f59e0b"],
    rose: ["bg-rose-50 text-rose-700", "#f43f5e"],
    sky: ["bg-sky-50 text-sky-700", "#0ea5e9"],
    slate: ["bg-slate-100 text-slate-700", "#64748b"],
  };
  return (
    <div className="stat-card relative overflow-hidden bg-white rounded-2xl border p-4 sm:p-5 fade-up" style={{ animationDelay: `${delay}ms`, "--tone": tones[tone][1] }} data-testid={testid}>
      <div className="flex items-start justify-between gap-2">
        <div className="text-xs font-semibold tracking-wide uppercase text-slate-500">{label}</div>
        {Icon && (
          <div className={`h-9 w-9 rounded-xl grid place-items-center ${tones[tone][0]}`}>
            <Icon className="h-4 w-4" />
          </div>
        )}
      </div>
      <div className="font-display text-3xl font-bold mt-2 text-slate-900" data-testid={`${testid}-value`}>{Number(value || 0).toLocaleString("id-ID")}</div>
      {sub && <div className="text-xs text-slate-500 mt-1">{sub}</div>}
    </div>
  );
};

export const PageHeader = ({ kicker, title, children }) => (
  <div className="page-header flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6 fade-up">
    <div className="pl-4 border-l-4" style={{ borderColor: "var(--accent)" }}>
      <p className="text-[11px] font-semibold tracking-[0.18em] uppercase" style={{ color: "var(--accent)" }}>{kicker}</p>
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900 mt-1">{title}</h1>
    </div>
    <div className="flex flex-wrap gap-2 no-print">{children}</div>
  </div>
);
